import { el } from 'https://cdn.venturz.co/lib/redom.es.js';

const showMoreLabel = 'Show more';
const retryLabel = 'Retry';

class ShowMoreControl {

  constructor(onLoadMore) {

    this.onLoadMore = onLoadMore;
    this.loading = false;

    this.spinner = el('ht-spinner.data-collection-show-more__spinner', { size: 'small' });
    this.spinner.setAttribute('aria-hidden', 'true');

    this.label = el('span.data-collection-show-more__label', showMoreLabel);

    this.button = el('button.data-collection-show-more__button', [this.spinner, this.label]);
    this.button.setAttribute('type', 'button');

    this.el = el('div.data-collection-show-more', [this.button]);

    this.handleClick = this.handleClick.bind(this);
    this.button.addEventListener('click', this.handleClick);

  }

  async handleClick() {

    if (this.loading === true) {
      return;
    }

    await this.onLoadMore();

  }

  startLoading() {

    this.loading = true;
    this.button.setAttribute('disabled', '');
    this.button.setAttribute('aria-busy', 'true');
    this.el.classList.add('data-collection-show-more--loading');

  }

  stopLoading() {

    this.loading = false;
    this.button.removeAttribute('disabled');
    this.button.removeAttribute('aria-busy');
    this.el.classList.remove('data-collection-show-more--loading');
    this.label.textContent = showMoreLabel;

  }

  showError() {

    this.loading = false;
    this.button.removeAttribute('disabled');
    this.button.removeAttribute('aria-busy');
    this.el.classList.remove('data-collection-show-more--loading');
    this.label.textContent = retryLabel;

  }

  remove() {

    if (this.el.parentNode !== null) {
      this.el.parentNode.removeChild(this.el);
    }

  }

}

export default ShowMoreControl;
